import { worksheetsK5 } from './worksheets-k-5';
import { worksheets68 } from './worksheets-6-8';
import { highSchoolWorksheets } from './worksheets-highschool';
import { worksheetsTestPrep } from './worksheets-testprep';
import { worksheetsStateTests } from './worksheets-statetests';
import { actMathWorksheets } from './worksheets-act-math';
import { actScienceWorksheets } from './worksheets-act-science';
import { actEnglishWorksheets } from './worksheets-act-english';

export interface Worksheet {
  id: string;
  title: string;
  description: string;
  grade: string;
  subject: string;
  topic: string;
  difficulty: 'Beginner' | 'Intermediate' | 'Advanced';
  pages: number;
  isFree: boolean;
  downloadUrl: string;
  thumbnailUrl: string;
}

export const allWorksheets: Worksheet[] = [
  ...worksheetsK5,
  ...worksheets68,
  ...highSchoolWorksheets,
  ...worksheetsTestPrep,
  ...worksheetsStateTests,
  ...actMathWorksheets,
  ...actScienceWorksheets,
  ...actEnglishWorksheets
];

export const gradeOptions = [
  'All Grades',
  'Kindergarten',
  'Grade 1',
  'Grade 2',
  'Grade 3',
  'Grade 4',
  'Grade 5',
  'Grade 6',
  'Grade 7',
  'Grade 8',
  'Algebra 1',
  'Geometry',
  'Algebra 2',
  'Pre-Calculus',
  'ACT Math',
  'ACT Science',
  'ACT English',
  'SAT Prep',
  'ACT Prep',
  'SHSAT Prep'
];

export const subjectOptions = [
  'All Subjects',
  'Math',
  'Algebra',
  'Geometry',
  'Pre-Calculus',
  'Test Prep'
];

export const topicOptions = [
  'All Topics',
  'Counting',
  'Shapes',
  'Patterns',
  'Addition',
  'Subtraction',
  'Multiplication',
  'Division',
  'Place Value',
  'Time',
  'Money',
  'Measurement',
  'Fractions',
  'Decimals',
  'Percents',
  'Ratios',
  'Proportions',
  'Integers',
  'Algebra',
  'Equations',
  'Inequalities',
  'Linear Functions',
  'Quadratics',
  'Polynomials',
  'Exponentials',
  'Logarithms',
  'Systems',
  'Sequences',
  'Complex Numbers',
  'Rational Functions',
  'Conics',
  'Geometry',
  'Area',
  'Perimeter',
  'Volume',
  'Angles',
  'Triangles',
  'Circles',
  'Congruence',
  'Transformations',
  'Coordinate Geometry',
  'Trigonometry',
  'Polar Coordinates',
  'Vectors',
  'Limits',
  'Matrices',
  'Graphing',
  'Probability',
  'Statistics',
  'Data',
  'Problem Solving',
  'Operations',
  'Exponents',
  'Full Test',
  'Pre-Algebra',
  'Elementary Algebra',
  'Intermediate Algebra',
  'Plane Geometry',
  'Interpretation of Data',
  'Scientific Investigation',
  'Evaluation of Models',
  'Biology Content',
  'Chemistry Content',
  'Physics Content',
  'Earth/Space Content',
  'Data Representation',
  'Research Summaries',
  'Conflicting Viewpoints',
  'Full Practice',
  'Punctuation',
  'Grammar and Usage',
  'Sentence Structure',
  'Rhetorical Skills',
  'Word Choice and Style',
];